module.exports = __webpack_public_path__ + "static/img/img_sanatorium.596fd52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile_barocare/img_sanatorium.jpg
// module id = 6HuN
// module chunks = 0